import { deepmerge } from '@utils/deepmerge';

export const buildChartJsOptionsProp = (options) => {
  return deepmerge({
    maintainAspectRatio: false,
    plugins: {
      datalabels: false,
      legend: { position: 'bottom' },
    },
    interaction: {
      axis: 'x',
      intersect: false,
      mode: 'nearest'
    },
    scales: {
      x: {
        grid: {
          display: false
        },
      },
      y: {
        beginAtZero: true,
        stacked: true,
        grid: {
          display: false
        },
      }
    },
    elements: {
      point: {
        hoverRadius: 0,
        radius: 0,
      }
    }
  }, options);
}
